<div class="packs-page">

  <div class="lx-page-header">
    <div>
      <p class="lx-page-eyebrow">{{ 'page.packs_eyebrow' | translate }}</p>
      <h2 class="lx-page-title">{{ 'page.packs_title' | translate }}</h2>
    </div>
    <button class="lx-btn lx-btn--primary" data-bs-toggle="modal" data-bs-target="#newPack">
      <span class="material-symbols-outlined">add</span>
      {{ 'btn.add_package' | translate }}
    </button>
  </div>

  <div class="app-card packs-table-card">
    <div class="lx-table-wrap">
      <table class="lx-table" *ngIf="dataFound">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'lbl.name' | translate }}</th>
            <th>{{ 'lbl.products' | translate }}</th>
            <th>{{ 'pack.quantities' | translate }}</th>
            <th>{{ 'lbl.discount' | translate }}</th>
            <th>{{ 'lbl.total_price' | translate }}</th>
            <th>{{ 'lbl.date' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of allPackages" (click)="packDetails(item.id)">
            <td class="cell-muted">{{ item.id }}</td>
            <td><strong>{{ item.name }}</strong></td>
            <td>
              <span class="packs-count-chip">{{ item.products.length }}</span>
            </td>
            <td>{{ item.quantities }}</td>
            <td>{{ item.discount }} <span class="packs-currency">LE</span></td>
            <td class="cell-price">{{ item.total_price }} <span class="packs-currency">LE</span></td>
            <td class="cell-date">{{ item.issue_date | date : "d MMM y" }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="lx-empty" *ngIf="!dataFound">
      <div class="lx-empty-icon">
        <span class="material-symbols-outlined">inventory_2</span>
      </div>
      <h3>{{ 'empty.packages' | translate }}</h3>
      <p>{{ 'empty.packages_sub' | translate }}</p>
    </div>
  </div>

</div>

<!-- ══════════════════════════════════════
     Add Package Modal
════════════════════════════════════════ -->
<div class="modal fade" id="newPack" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="lx-modal-content">
      <div class="lx-modal-header lx-modal-header--row">
        <div>
          <p class="lx-modal-eyebrow">{{ 'page.packs_eyebrow' | translate }}</p>
          <h5 class="lx-modal-title">{{ 'btn.add_package' | translate }}</h5>
        </div>
        <button type="button" class="lx-modal-close" data-bs-dismiss="modal">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>
      <div class="lx-modal-body">
        <div *ngIf="packImageStatus">
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'pack.category' | translate }}</label>
            <div class="lx-dropdown-wrap">
              <button class="lx-dropdown-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <span class="material-symbols-outlined">category</span>
                {{ 'btn.choose_category' | translate }}
                <span class="material-symbols-outlined lx-dropdown-caret">expand_more</span>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" (click)="getCatId(item)" *ngFor="let item of cat_arr">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <span class="lx-selection-hint" *ngIf="catName">Selected: <strong>{{ catName }}</strong></span>
          </div>

          <div class="lx-field-group" *ngIf="status_prod">
            <label class="lx-field-label">{{ 'lbl.product' | translate }}</label>
            <div class="lx-dropdown-wrap" *ngIf="ifProd">
              <button class="lx-dropdown-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                <span class="material-symbols-outlined">inventory_2</span>
                {{ 'btn.choose_product' | translate }}
                <span class="material-symbols-outlined lx-dropdown-caret">expand_more</span>
              </button>
              <ul class="dropdown-menu">
                <li *ngFor="let item of prod_arr">
                  <a class="dropdown-item" *ngIf="item.quantity > 0" (click)="choseProd(item)">{{ item.name }}</a>
                </li>
              </ul>
            </div>
            <span class="lx-selection-hint" *ngIf="ifProd && prodName">Selected: <strong>{{ prodName }}</strong></span>
            <p class="lx-field-error" *ngIf="!ifProd">{{ 'empty.no_cat_products' | translate }}</p>
          </div>

          <div class="lx-field-group" *ngIf="ifProd">
            <label class="lx-field-label">{{ 'pack.product_qty' | translate }}</label>
            <input type="number" [(ngModel)]="Quantity" class="lx-input" [placeholder]="'ph.quantity' | translate" />
          </div>

          <button *ngIf="ifProd" class="lx-btn lx-btn--success" (click)="add()" style="margin-bottom: 4px;">
            <span class="material-symbols-outlined">add</span>
            {{ 'btn.add_to_package' | translate }}
          </button>

          <div class="pack-items-list" *ngIf="arrayChoiceProduct.length > 0">
            <p class="lx-field-label" style="margin-bottom: 6px;">{{ 'pack.items' | translate }}</p>
            <div class="pack-item" *ngFor="let item of arrayChoiceProduct">
              <span class="material-symbols-outlined">check_circle</span>
              {{ item }}
            </div>
          </div>

          <div class="lx-field-group" style="margin-top: 8px;">
            <label class="lx-field-label">{{ 'pack.pack_name' | translate }}</label>
            <input type="text" [(ngModel)]="pack_name" class="lx-input" [placeholder]="'ph.pack_name' | translate" />
          </div>
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'lbl.discount' | translate }} (LE)</label>
            <input type="text" [(ngModel)]="discount" class="lx-input" [placeholder]="'ph.price' | translate" />
          </div>
        </div>

        <div *ngIf="!packImageStatus">
          <div class="lx-field-group">
            <label class="lx-field-label">{{ 'pack.image_label' | translate }}</label>
            <input (change)="uploadFile($event)" type="file" class="lx-input lx-file-input" />
          </div>
        </div>
      </div>
      <div class="lx-modal-footer">
        <button type="button" class="lx-btn lx-btn--ghost" data-bs-dismiss="modal">{{ 'btn.cancel' | translate }}</button>
        <button *ngIf="packImageStatus" (click)="save()" type="button" class="lx-btn lx-btn--primary">
          {{ 'btn.continue' | translate }}
          <span class="material-symbols-outlined">arrow_forward</span>
        </button>
        <button data-bs-dismiss="modal" *ngIf="!packImageStatus" (click)="addPackImage()" type="button" class="lx-btn lx-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_package' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
